import type { AssetItem } from '@/components/common/TableAdvancedFilters/AssetFilter'

import { AssetFilter } from '@/helpers/filter/table'

export interface FilterDefinition {
  value: AssetFilter
  label: string
  tooltip?: string
  filterMethod: 'tag' | 'prefix'
  filterValue?: string
}

export const BASE_FILTER_DEFINITIONS: FilterDefinition[] = [
  {
    value: AssetFilter.ALL,
    label: 'All',
    filterMethod: 'tag'
  },
  {
    value: AssetFilter.ETH,
    label: 'Eth',
    tooltip: 'All ETH related/derivative assets.',
    filterMethod: 'tag'
  },
  {
    value: AssetFilter.BTC,
    label: 'Btc',
    tooltip: 'All BTC related/derivative assets.',
    filterMethod: 'tag'
  },
  {
    value: AssetFilter.STABLECOIN,
    label: 'Stables',
    tooltip: 'Assets pegged to fiat currencies.',
    filterMethod: 'tag'
  }
]

export const PT_FILTER_DEFINITION: FilterDefinition = {
  value: AssetFilter.PT,
  label: 'PT',
  tooltip: 'All Principal Token (PT) assets.',
  filterMethod: 'prefix',
  filterValue: 'PT-'
}

export const STOCKS_FILTER_DEFINITION: FilterDefinition = {
  value: AssetFilter.STOCKS,
  label: 'Stocks',
  tooltip: 'Tokenized stock assets.',
  filterMethod: 'tag'
}

export function getAssetIdsByFilter(assets: AssetItem[], filterDef: FilterDefinition): string[] {
  if (filterDef.value === AssetFilter.ALL) return []

  const filterFn =
    filterDef.filterMethod === 'tag'
      ? (asset: AssetItem) => asset.tags?.includes(filterDef.value)
      : (asset: AssetItem) => asset.symbol.startsWith(filterDef.filterValue || filterDef.value)

  return assets.filter(filterFn).map(asset => asset.id)
}
